
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"24","viewBox":"0 0 21 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.0196 3.62604C11.7066 3.62604 13.2339 4.30985 14.3395 5.41542C15.4451 6.52099 16.1289 8.04832 16.1289 9.73536L16.1289 16.0409L19.8497 19.7172L0.189453 19.7172L3.91023 16.0409L3.91023 9.73536C3.91023 8.04832 4.59404 6.52099 5.69961 5.41542C6.80518 4.30985 8.33251 3.62604 10.0196 3.62604Z","stroke":"#B7B7B7","stroke-width":"1.425","stroke-linejoin":"round"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.0355 22.3843C9.49122 22.3843 9.00634 22.1847 8.64255 21.8622C8.0929 21.3748 7.81745 20.6041 8.02917 19.7845L11.951 19.5974C12.2501 20.4441 12.0094 21.2579 11.4821 21.7851C11.1119 22.1554 10.6004 22.3843 10.0355 22.3843Z","stroke":"#B7B7B7","stroke-width":"1.425","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M10.0197 3.71768C10.7857 3.71768 11.4068 3.10021 11.4068 2.33852C11.4068 1.57682 10.7857 0.959351 10.0197 0.959351C9.2536 0.959351 8.63257 1.57682 8.63257 2.33852C8.63257 3.10021 9.2536 3.71768 10.0197 3.71768Z","stroke":"#B7B7B7","stroke-width":"1.425"}})])
          )
        }
      }
    